import MobileForgottenPassword from './MobileForgottenPassword';
export default MobileForgottenPassword;
